module.exports = __webpack_public_path__ + "1.4.15-unryo/img/juniper-networks.5604ab05.svg";